// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"47a722e8","959":"23978ed9"}[chunkId] + ".chunk.js";
};